import './ToolbarComponent.style.less'
import { Button, Input, Row } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

type Props = {
  title?: string
  onAdd?: () => void
  buttonText?: string
  onSearch?: (value: string) => void
  isSearch?: boolean
  subTitle?: string
}
const { Search } = Input

function ToolbarComponent(props: Props) {
  const { isSearch = true } = props
  return (
    <Row justify={'space-between'} align={'middle'}>
      <p className="sub-title-container-toolbar">{props.subTitle}</p>
      <div className="container-toolbar">
        {isSearch && (
          <Search
            placeholder="Search"
            className="search-input"
            onChange={(e) => props.onSearch(e.target.value)}
            size="large"
            onSearch={(e) => {
              props.onSearch(e)
            }}
          />
        )}
        {props.onAdd && props.buttonText && (
          <Button size="large" type="primary" onClick={props.onAdd}>
            <PlusOutlined />
            {props.buttonText ?? 'Add New'}
          </Button>
        )}
      </div>
    </Row>
  )
}

export default ToolbarComponent
